import { AccountNotes, Icons } from '@ltvco/refresh-lib';
import { Typography } from '@mui/material'; 
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';

const FlexContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

const Title = styled(Typography)(({ theme }) => ({
    alignSelf: 'baseline',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    fontSize: '1.875rem',
    fontWeight: 'bold',
    fontFamily: "'Lato', sans-serif"
  }));

export function Notes() {
    useEffect(() => {
        document.title = 'Notes - PeopleSmart';
    }, []);

    return (
        <FlexContainer>
            <Title variant="h1">
                <Icons.EditNote
                    color="primary"
                    sx={{ marginRight: '4px', height: '40px', width: '40px' }}
                    fontSize="large"
                />
                Private Notes
            </Title>
            <AccountNotes />
        </FlexContainer>
    );
}
